import { ROW_GAP, ROW_HEIGHT } from './CourtSchedule'
import { getServerDate, isToday } from '../../util/serverTimeUtil'
import { useEffect, useState } from 'react'

import { getBookingScheduleInfo } from '../../util/bookingUtil'

const getMarkerOffset = (date) => {
  if (!date) return -1

  const { START_HOUR, END_HOUR } = getBookingScheduleInfo(date)
  const hours = date.getHours()
  const minutes = date.getMinutes()

  if (hours > END_HOUR) return -1

  const decimalHoursPassed = hours - START_HOUR + minutes / 60
  return decimalHoursPassed * (ROW_HEIGHT + ROW_GAP + 1)
}

export default function TimeMarker({ date, showEndDot = true }) {
  const COLOUR = '#ff4d5044'
  let COLOUR2 = COLOUR.substring(0, 7) + 'cc'

  const [offset, setOffset] = useState(getMarkerOffset(date))

  useEffect(() => {
    const interval = setInterval(() => {
      const val = getMarkerOffset(getServerDate())
      setOffset(val)
    }, 60 * 1000) // Update every minute

    return () => clearInterval(interval)
  }, [date])

  if (!date || !isToday(date)) {
    return null
  }

  // Hide the marker if the time is before the grid starts
  if (offset < 0) return null

  return (
    <div
      style={{
        gridColumn: '1 / -1', // Spans from the first column to the last
        gridRow: '2', // Stays in the first row context so 'top' is relative to the grid top
        position: 'relative',
        pointerEvents: 'none',
        zIndex: 1,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: `${offset}px`,
          left: 40,
          right: -10,
          height: '0px', // Set height to 0 so 'top' is exactly the line
          borderTop: '2px solid ' + COLOUR, // Use border instead of height
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            width: '10px',
            height: '10px',
            backgroundColor: COLOUR2,
            borderRadius: '50%',
            marginLeft: '-9px',
            marginTop: '-2px',
          }}
        />
        {showEndDot && (
          <div
            style={{
              width: '10px',
              height: '10px',
              backgroundColor: COLOUR2,
              borderRadius: '50%',
              marginRight: '-10px',
              marginTop: '-2px',
            }}
          />
        )}
      </div>
    </div>
  )
}
